export default {
  data() {
    return {
      columnData: [],
      tableDataSet: [],
      reportName: 'hierarchyList',
      tableVisible: false,
      tableReload: true
    }
  },
  mounted() {
    this.columns()
  },
  methods: {
    columns(type) {
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then(res => {
        this.columnsData = res.data
        let data = res.data.userColumns.length ? res.data.userColumns : res.data.sysColumns
        let list = []
        data.forEach(v => {
          list.push({
            displayName: v.displayName,
            displayWidth: v.displayWidthNum,
            freezeLeft: v.freezeType == 'left' ? true : false,
            freezeRight: v.freezeType == 'right' ? true : false,
            isShow: v.isShow,
            columnName: v.columnName
          })
        });
        this.tableDataSet = list
        if(!type) {
          this.customColumn(this.columnsData)
        }
      });
    },
    closeAddForm() {
      this.tableVisible = false;
      this.columns(true)
    },
    confirm() {
      let data = []
      console.log(this.tableDataSet);
      this.tableDataSet.forEach(v => {
        let freezeFlag = v.freezeLeft || v.freezeRight ? true : false
        data.push({
          displayName: v.displayName,
          columnName: v.columnName,
          displayWidth: v.displayWidth,
          reportName: this.reportName,
          freezeFlag: freezeFlag,
          freezeType: freezeFlag && v.freezeLeft ? 'left' : freezeFlag && v.freezeRight ? 'right' : '',
          isShow: v.isShow
        })
      })
      this.$q.common.mergeColumns({ data: data }).then(res => {
        if (res.success) {
          this.$message.success('自定义配置成功')
          this.tableReload = false
          this.$nextTick(_ => {
            this.tableReload = true;
          });
          this.columns()
        } else {
          this.$message.error('自定义配置失败')
        }
        this.closeAddForm()
      });
    },
    async customColumn(data) {
      if (data.userColumns.length) {
        data = data.userColumns.filter(v=>!v.isShow)
      } else {
        data = data.sysColumns
      }
      this.columnData = []
      data.forEach(v => {
        this.columnData.push({
          label: v.displayName,
          prop: v.columnName,
          width: v.displayWidth,
          sortable: v.sortable == '1' ? "custom" : false,
          span: false,
          fixed: v.freezeType,
        })
      })
    }
  }
}